import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiProductsList, apiProductsView } from 'Services/UserService'

export const getData = createAsyncThunk('user/products/getData', async datas => {
    const { data } = await apiProductsList(datas)
    return data
})

export const getView = createAsyncThunk('user/products/getView', async id => {
    if (!id) return viewData
    const { data } = await apiProductsView(id)
    return data
})

const viewData = {
    brand_id: '',
    category_id: '',
    name: '',
    price: '',
    unit: '',
}

export const productsSlice = createSlice({
    name: 'user/products',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            store_id: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setStore: (state, { payload }) => {
            state.table.store_id = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setStore } = productsSlice.actions

export default productsSlice.reducer
